import * as React from 'react';

const AppleCalendar = (props) => (
  <svg
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 56.25 53"
    {...props}
  >
    <path
      d="M50 3.5h-4.42V1.25a1.25 1.25 0 0 0-2.5 0V3.5H29.12V1.25a1.25 1.25 0 0 0-2.5 0V3.5h-14V1.25a1.25 1.25 0 0 0-2.5 0V3.5H6.24A6.24 6.24 0 0 0 0 9.75v37A6.24 6.24 0 0 0 6.24 53H50a6.24 6.24 0 0 0 6.24-6.25v-37A6.24 6.24 0 0 0 50 3.5ZM6.24 6h3.88v2.83a1.25 1.25 0 0 0 2.5 0V6h14v2.83a1.25 1.25 0 0 0 2.5 0V6h14v2.83a1.25 1.25 0 0 0 2.5 0V6h4.42a3.74 3.74 0 0 1 3.74 3.75v7.33H2.5V9.75A3.74 3.74 0 0 1 6.24 6ZM50 50.5H6.24a3.74 3.74 0 0 1-3.74-3.75V19.58h51.24v27.17A3.74 3.74 0 0 1 50 50.5Z"/>
    <path
      d="M39.38 40.85a6.11 6.11 0 0 1 2.92-5.15 6.34 6.34 0 0 0-4.95-2.7c-2.1-.21-4.1 1.24-5.17 1.24s-2.71-1.2-4.46-1.17a6.6 6.6 0 0 0-5.59 3.39c-2.38 4.13-.61 10.26 1.71 13.61 1.14 1.64 2.49 3.49 4.27 3.42s2.36-1.11 4.42-1.11 2.65 1.11 4.46 1.07 3-1.67 4.14-3.32A14.77 14.77 0 0 0 43 46.31a6 6 0 0 1-3.63-5.46ZM36 30.8a5.92 5.92 0 0 0 1.4-4.31 6 6 0 0 0-4 2.05 5.66 5.66 0 0 0-1.4 4.18 5 5 0 0 0 4-1.91Z"
      transform="translate(-3.88 -5.5)"
      style={{
        fillRule: 'evenodd',
      }}
    />
  </svg>
);

export default AppleCalendar;
